import HeroVideo from 'common/hero_video';
import { initializeShopNowModal } from 'pages/home/modals';

class Homepage {
  constructor() {
    this.heroVideo = new HeroVideo();
    this.initializeShopNowButton();
    initializeShopNowModal();
  }

  initializeShopNowButton() {
    this.shopNowButtonEl = document.querySelector('.js-shop-now-button');
    // there may not be a "shop now" button in certain locales
    if (this.shopNowButtonEl) {
      this.footerEl = document.querySelector('.js-footer');
      window.addEventListener('scroll', this.handleShopNowWindowScroll);
    }
  }

  handleShopNowWindowScroll = () => {
    let buttonToFooterPixels =
      this.footerEl.offsetTop -
      window.scrollY -
      document.documentElement.clientHeight;

    if (this.shopNowButtonEl.style.position !== 'fixed') {
      buttonToFooterPixels -= 2 * this.shopNowButtonEl.clientHeight;
    }

    const position = buttonToFooterPixels > 0 ? 'fixed' : 'initial';
    this.shopNowButtonEl.style.position = position;
  };
}

if (document.querySelector('.js-home-page')) {
  new Homepage();
}
